import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VNetworkGraph from 'v-network-graph'
import 'v-network-graph/lib/style.css'
import App from './App.vue'
import router from './router'
import './assets/main.css'

// Liaison du store auth avec le client Axios (évite la dépendance circulaire au module level)
import { setAuthStoreGetter } from './services/client'
import { setNotifier } from './services/notifier'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(VNetworkGraph)

// Configuration post-pinia
import { useAuthStore } from './stores/auth'
import { useNotificationsStore } from './stores/notifications'

setAuthStoreGetter(() => {
  const store = useAuthStore()
  return {
    accessToken: store.accessToken,
    refreshToken: () => store.refreshToken(),
  }
})

// Démarrer le refresh proactif du token (visibilitychange + timer 10 min)
useAuthStore().startTokenRefresh()

setNotifier((message, type) => {
  const notifStore = useNotificationsStore()
  if (type === 'error') notifStore.pushError(message)
  else if (type === 'success') notifStore.pushSuccess(message)
  else notifStore.pushInfo(message)
})

app.mount('#app')
